"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../vuetify2-themes/dist/index.js
var require_dist = __commonJS({
  "../vuetify2-themes/dist/index.js"(exports2, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var index_exports2 = {};
    __export2(index_exports2, {
      AdminTheme: () => AdminTheme,
      AllThemes: () => AllThemes,
      AudiTheme: () => AudiTheme,
      BnpTheme: () => BnpTheme4,
      CondorTheme: () => CondorTheme,
      HoermannTheme: () => HoermannTheme,
      MauserTheme: () => MauserTheme,
      NahshTheme: () => NahshTheme,
      TestTheme: () => TestTheme,
      ThemeNames: () => ThemeNames,
      WsmTheme: () => WsmTheme
    });
    module2.exports = __toCommonJS2(index_exports2);
    var red = Object.freeze({
      base: "#f44336",
      lighten5: "#ffebee",
      lighten4: "#ffcdd2",
      lighten3: "#ef9a9a",
      lighten2: "#e57373",
      lighten1: "#ef5350",
      darken1: "#e53935",
      darken2: "#d32f2f",
      darken3: "#c62828",
      darken4: "#b71c1c",
      accent1: "#ff8a80",
      accent2: "#ff5252",
      accent3: "#ff1744",
      accent4: "#d50000"
    });
    var pink = Object.freeze({
      base: "#e91e63",
      lighten5: "#fce4ec",
      lighten4: "#f8bbd0",
      lighten3: "#f48fb1",
      lighten2: "#f06292",
      lighten1: "#ec407a",
      darken1: "#d81b60",
      darken2: "#c2185b",
      darken3: "#ad1457",
      darken4: "#880e4f",
      accent1: "#ff80ab",
      accent2: "#ff4081",
      accent3: "#f50057",
      accent4: "#c51162"
    });
    var purple = Object.freeze({
      base: "#9c27b0",
      lighten5: "#f3e5f5",
      lighten4: "#e1bee7",
      lighten3: "#ce93d8",
      lighten2: "#ba68c8",
      lighten1: "#ab47bc",
      darken1: "#8e24aa",
      darken2: "#7b1fa2",
      darken3: "#6a1b9a",
      darken4: "#4a148c",
      accent1: "#ea80fc",
      accent2: "#e040fb",
      accent3: "#d500f9",
      accent4: "#aa00ff"
    });
    var deepPurple = Object.freeze({
      base: "#673ab7",
      lighten5: "#ede7f6",
      lighten4: "#d1c4e9",
      lighten3: "#b39ddb",
      lighten2: "#9575cd",
      lighten1: "#7e57c2",
      darken1: "#5e35b1",
      darken2: "#512da8",
      darken3: "#4527a0",
      darken4: "#311b92",
      accent1: "#b388ff",
      accent2: "#7c4dff",
      accent3: "#651fff",
      accent4: "#6200ea"
    });
    var indigo = Object.freeze({
      base: "#3f51b5",
      lighten5: "#e8eaf6",
      lighten4: "#c5cae9",
      lighten3: "#9fa8da",
      lighten2: "#7986cb",
      lighten1: "#5c6bc0",
      darken1: "#3949ab",
      darken2: "#303f9f",
      darken3: "#283593",
      darken4: "#1a237e",
      accent1: "#8c9eff",
      accent2: "#536dfe",
      accent3: "#3d5afe",
      accent4: "#304ffe"
    });
    var blue = Object.freeze({
      base: "#2196f3",
      lighten5: "#e3f2fd",
      lighten4: "#bbdefb",
      lighten3: "#90caf9",
      lighten2: "#64b5f6",
      lighten1: "#42a5f5",
      darken1: "#1e88e5",
      darken2: "#1976d2",
      darken3: "#1565c0",
      darken4: "#0d47a1",
      accent1: "#82b1ff",
      accent2: "#448aff",
      accent3: "#2979ff",
      accent4: "#2962ff"
    });
    var lightBlue = Object.freeze({
      base: "#03a9f4",
      lighten5: "#e1f5fe",
      lighten4: "#b3e5fc",
      lighten3: "#81d4fa",
      lighten2: "#4fc3f7",
      lighten1: "#29b6f6",
      darken1: "#039be5",
      darken2: "#0288d1",
      darken3: "#0277bd",
      darken4: "#01579b",
      accent1: "#80d8ff",
      accent2: "#40c4ff",
      accent3: "#00b0ff",
      accent4: "#0091ea"
    });
    var cyan = Object.freeze({
      base: "#00bcd4",
      lighten5: "#e0f7fa",
      lighten4: "#b2ebf2",
      lighten3: "#80deea",
      lighten2: "#4dd0e1",
      lighten1: "#26c6da",
      darken1: "#00acc1",
      darken2: "#0097a7",
      darken3: "#00838f",
      darken4: "#006064",
      accent1: "#84ffff",
      accent2: "#18ffff",
      accent3: "#00e5ff",
      accent4: "#00b8d4"
    });
    var teal = Object.freeze({
      base: "#009688",
      lighten5: "#e0f2f1",
      lighten4: "#b2dfdb",
      lighten3: "#80cbc4",
      lighten2: "#4db6ac",
      lighten1: "#26a69a",
      darken1: "#00897b",
      darken2: "#00796b",
      darken3: "#00695c",
      darken4: "#004d40",
      accent1: "#a7ffeb",
      accent2: "#64ffda",
      accent3: "#1de9b6",
      accent4: "#00bfa5"
    });
    var green = Object.freeze({
      base: "#4caf50",
      lighten5: "#e8f5e9",
      lighten4: "#c8e6c9",
      lighten3: "#a5d6a7",
      lighten2: "#81c784",
      lighten1: "#66bb6a",
      darken1: "#43a047",
      darken2: "#388e3c",
      darken3: "#2e7d32",
      darken4: "#1b5e20",
      accent1: "#b9f6ca",
      accent2: "#69f0ae",
      accent3: "#00e676",
      accent4: "#00c853"
    });
    var lightGreen = Object.freeze({
      base: "#8bc34a",
      lighten5: "#f1f8e9",
      lighten4: "#dcedc8",
      lighten3: "#c5e1a5",
      lighten2: "#aed581",
      lighten1: "#9ccc65",
      darken1: "#7cb342",
      darken2: "#689f38",
      darken3: "#558b2f",
      darken4: "#33691e",
      accent1: "#ccff90",
      accent2: "#b2ff59",
      accent3: "#76ff03",
      accent4: "#64dd17"
    });
    var lime = Object.freeze({
      base: "#cddc39",
      lighten5: "#f9fbe7",
      lighten4: "#f0f4c3",
      lighten3: "#e6ee9c",
      lighten2: "#dce775",
      lighten1: "#d4e157",
      darken1: "#c0ca33",
      darken2: "#afb42b",
      darken3: "#9e9d24",
      darken4: "#827717",
      accent1: "#f4ff81",
      accent2: "#eeff41",
      accent3: "#c6ff00",
      accent4: "#aeea00"
    });
    var yellow = Object.freeze({
      base: "#ffeb3b",
      lighten5: "#fffde7",
      lighten4: "#fff9c4",
      lighten3: "#fff59d",
      lighten2: "#fff176",
      lighten1: "#ffee58",
      darken1: "#fdd835",
      darken2: "#fbc02d",
      darken3: "#f9a825",
      darken4: "#f57f17",
      accent1: "#ffff8d",
      accent2: "#ffff00",
      accent3: "#ffea00",
      accent4: "#ffd600"
    });
    var amber = Object.freeze({
      base: "#ffc107",
      lighten5: "#fff8e1",
      lighten4: "#ffecb3",
      lighten3: "#ffe082",
      lighten2: "#ffd54f",
      lighten1: "#ffca28",
      darken1: "#ffb300",
      darken2: "#ffa000",
      darken3: "#ff8f00",
      darken4: "#ff6f00",
      accent1: "#ffe57f",
      accent2: "#ffd740",
      accent3: "#ffc400",
      accent4: "#ffab00"
    });
    var orange = Object.freeze({
      base: "#ff9800",
      lighten5: "#fff3e0",
      lighten4: "#ffe0b2",
      lighten3: "#ffcc80",
      lighten2: "#ffb74d",
      lighten1: "#ffa726",
      darken1: "#fb8c00",
      darken2: "#f57c00",
      darken3: "#ef6c00",
      darken4: "#e65100",
      accent1: "#ffd180",
      accent2: "#ffab40",
      accent3: "#ff9100",
      accent4: "#ff6d00"
    });
    var deepOrange = Object.freeze({
      base: "#ff5722",
      lighten5: "#fbe9e7",
      lighten4: "#ffccbc",
      lighten3: "#ffab91",
      lighten2: "#ff8a65",
      lighten1: "#ff7043",
      darken1: "#f4511e",
      darken2: "#e64a19",
      darken3: "#d84315",
      darken4: "#bf360c",
      accent1: "#ff9e80",
      accent2: "#ff6e40",
      accent3: "#ff3d00",
      accent4: "#dd2c00"
    });
    var brown = Object.freeze({
      base: "#795548",
      lighten5: "#efebe9",
      lighten4: "#d7ccc8",
      lighten3: "#bcaaa4",
      lighten2: "#a1887f",
      lighten1: "#8d6e63",
      darken1: "#6d4c41",
      darken2: "#5d4037",
      darken3: "#4e342e",
      darken4: "#3e2723"
    });
    var blueGrey = Object.freeze({
      base: "#607d8b",
      lighten5: "#eceff1",
      lighten4: "#cfd8dc",
      lighten3: "#b0bec5",
      lighten2: "#90a4ae",
      lighten1: "#78909c",
      darken1: "#546e7a",
      darken2: "#455a64",
      darken3: "#37474f",
      darken4: "#263238"
    });
    var grey = Object.freeze({
      base: "#9e9e9e",
      lighten5: "#fafafa",
      lighten4: "#f5f5f5",
      lighten3: "#eeeeee",
      lighten2: "#e0e0e0",
      lighten1: "#bdbdbd",
      darken1: "#757575",
      darken2: "#616161",
      darken3: "#424242",
      darken4: "#212121"
    });
    var shades = Object.freeze({
      black: "#000000",
      white: "#ffffff",
      transparent: "transparent"
    });
    var colors_default = Object.freeze({
      red,
      pink,
      purple,
      deepPurple,
      indigo,
      blue,
      lightBlue,
      cyan,
      teal,
      green,
      lightGreen,
      lime,
      yellow,
      amber,
      orange,
      deepOrange,
      brown,
      blueGrey,
      grey,
      shades
    });
    var AudiTheme = {
      name: "AUDI",
      font: '"Audi-Wide-Light",Arial,sans-serif',
      loginBackground: "background-color: #fff",
      vuetifyLightTheme: {
        primary: "#000",
        secondary: "#FF664C",
        accent: "#f50537",
        success: "#0DA20D",
        info: "#0084bd",
        warning: colors_default.amber.darken1,
        error: "#FF664C",
        green: "#0DA20D",
        red: "#FF664C",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#333"
      },
      vuetifyDarkTheme: {
        primary: "#006bac",
        secondary: "#e01e15",
        accent: "#f59b21",
        success: "#006cad",
        info: "#006cad",
        warning: colors_default.amber.darken1,
        error: "#e01e15",
        green: "#00ae4f",
        red: "#e01e15",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#006bac"
      }
    };
    var BnpTheme4 = {
      name: "BNP",
      font: '"Roboto", sans-serif',
      loginBackground: "background-image: linear-gradient(to right top, #80ba27, #00b66c,  #00aba1, #009abf, #0084bd);",
      vuetifyLightTheme: {
        primary: "#0084bd",
        secondary: "#80ba26",
        accent: "#80ba26",
        success: "#80ba26",
        info: "#0084bd",
        warning: colors_default.amber.darken1,
        error: "#FF664C",
        green: "#80ba26",
        red: "#FF664C",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#2F4858"
      },
      vuetifyDarkTheme: {
        primary: "#0084bd",
        secondary: "#80ba26",
        accent: "#80ba26",
        success: "#80ba26",
        info: "#0084bd",
        warning: colors_default.amber.darken1,
        error: "#FF664C",
        green: "#80ba26",
        red: "#FF664C",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#2F4858"
      }
    };
    var CondorTheme = {
      name: "CONDOR",
      font: '"Helvetica Neue LT Bold",Arial,sans-serif',
      loginBackground: "background-color: #006bac",
      vuetifyLightTheme: {
        primary: "#006bac",
        secondary: "#f59b21",
        accent: "#f59b21",
        success: "#006cad",
        info: "#006cad",
        warning: colors_default.amber.darken1,
        error: "#e01e15",
        green: "#00ae4f",
        red: "#e01e15",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#006bac"
      },
      vuetifyDarkTheme: {
        primary: "#006bac",
        secondary: "#f59b21",
        accent: "#f59b21",
        success: "#006cad",
        warning: colors_default.amber.darken1,
        error: "#e01e15",
        info: "#006cad",
        green: "#00ae4f",
        red: "#e01e15",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#006bac"
      }
    };
    var HoermannTheme = {
      name: "HOERMANN",
      font: '"Roboto",Arial,Helvetica,sans-serif',
      loginBackground: "background-color: #003A7D",
      vuetifyLightTheme: {
        primary: "#003A7D",
        secondary: "#F9AD09",
        accent: "#F9AD09",
        success: "#a5cc00",
        info: "#003A7D",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#a5cc00",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#003A7D"
      },
      vuetifyDarkTheme: {
        primary: "#003A7D",
        secondary: "#F9AD09",
        accent: "#F9AD09",
        success: "#a5cc00",
        info: "#003A7D",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#a5cc00",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#003A7D"
      }
    };
    var MauserTheme = {
      name: "MAUSER",
      font: "Inter, sans-serif",
      loginBackground: "background-color: #37393f",
      vuetifyLightTheme: {
        primary: "#37393f",
        secondary: "#37393f",
        accent: "#37393f",
        success: "#37393f",
        info: "#37393f",
        warning: colors_default.amber.darken1,
        error: "#e01e15",
        green: "#8FC96B",
        red: "#e01e15",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#37393f"
      },
      vuetifyDarkTheme: {
        primary: "#37393f",
        secondary: "#37393f",
        accent: "#37393f",
        success: "#37393f",
        info: "#37393f",
        warning: colors_default.amber.darken1,
        error: "#e01e15",
        green: "#8FC96B",
        red: "#e01e15",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#37393f"
      }
    };
    var NahshTheme = {
      name: "NAHSH",
      font: '"Nunito Sans", sans-serif',
      loginBackground: "background-color: #001f48",
      vuetifyLightTheme: {
        primary: "#001f48",
        secondary: "#1b8187",
        accent: "#1b8187",
        success: "#1b8187",
        info: "#1b8187",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#2d9563",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#001f48",
        surface: "#eaebed"
      },
      vuetifyDarkTheme: {
        primary: "#001f48",
        secondary: "#1b8187",
        accent: "#1b8187",
        success: "#1b8187",
        info: "#1b8187",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#2d9563",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#001f48"
      }
    };
    var TestTheme = {
      name: "TEST",
      font: "Roboto",
      loginBackground: "",
      vuetifyLightTheme: {
        primary: "#0ff",
        secondary: "#0fa",
        accent: "#0fa",
        success: "#0f0",
        info: "#ff0",
        warning: colors_default.amber.darken1,
        error: "#f00",
        green: "#0a0",
        red: "#f00",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#0af"
      },
      vuetifyDarkTheme: {
        primary: "#0ff",
        secondary: "#0fa",
        accent: "#0fa",
        success: "#0f0",
        info: "#ff0",
        warning: colors_default.amber.darken1,
        error: "#f00",
        green: "#0a0",
        red: "#f00",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#0af"
      }
    };
    var WsmTheme = {
      name: "WSM",
      font: '"Myriad",Arial,sans-serif',
      loginBackground: "background-color: #008436",
      vuetifyLightTheme: {
        primary: "#008436",
        secondary: "#aed5ad",
        accent: "#aed5ad",
        success: "#008436",
        info: "#aed5ad",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#008436",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#008436"
      },
      vuetifyDarkTheme: {
        primary: "#008436",
        secondary: "#aed5ad",
        accent: "#aed5ad",
        success: "#008436",
        info: "#aed5ad",
        warning: colors_default.amber.darken1,
        error: "#e94550",
        green: "#008436",
        red: "#e94550",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#008436"
      }
    };
    var AdminTheme = {
      name: "ADMIN",
      font: '"Roboto", sans-serif',
      loginBackground: "background-image: linear-gradient(to right top, #46080a, #e5686c);",
      vuetifyLightTheme: {
        primary: "#0084bd",
        secondary: "#80ba26",
        accent: "#80ba26",
        success: "#80ba26",
        info: "#0084bd",
        warning: colors_default.amber.darken1,
        error: "#FF664C",
        green: "#80ba26",
        red: "#FF664C",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#800e0e"
      },
      vuetifyDarkTheme: {
        primary: "#0084bd",
        secondary: "#80ba26",
        accent: "#80ba26",
        success: "#80ba26",
        info: "#0084bd",
        warning: colors_default.amber.darken1,
        error: "#FF664C",
        green: "#80ba26",
        red: "#FF664C",
        "status-restarting": colors_default.amber.darken4,
        "status-generating": colors_default.purple.accent3,
        "status-pending": colors_default.amber.darken1,
        "status-active": colors_default.green.lighten1,
        "status-unreachable": colors_default.red.darken2,
        "status-all": colors_default.blue.lighten1,
        navbar: "#800e0e"
      }
    };
    var ThemeNames = /* @__PURE__ */ ((ThemeNames2) => {
      ThemeNames2["AUDI"] = "AUDI";
      ThemeNames2["ADMIN"] = "ADMIN";
      ThemeNames2["BNP"] = "BNP";
      ThemeNames2["CONDOR"] = "CONDOR";
      ThemeNames2["HOERMANN"] = "HOERMANN";
      ThemeNames2["MAUSER"] = "MAUSER";
      ThemeNames2["NAHSH"] = "NAHSH";
      ThemeNames2["TEST"] = "TEST";
      ThemeNames2["WSM"] = "WSM";
      return ThemeNames2;
    })(ThemeNames || {});
    var AllThemes = [
      AudiTheme,
      AdminTheme,
      BnpTheme4,
      CondorTheme,
      HoermannTheme,
      MauserTheme,
      NahshTheme,
      TestTheme,
      WsmTheme
    ];
  }
});

// src/index.ts
var index_exports = {};
__export(index_exports, {
  DefaultLocalConfig: () => DefaultLocalConfig,
  DefaultProductionConfig: () => DefaultProductionConfig,
  DefaultStagingConfig: () => DefaultStagingConfig,
  defineConfig: () => defineConfig,
  getBrandTheme: () => getBrandTheme
});
module.exports = __toCommonJS(index_exports);

// ../themes/src/index.ts
var DEFAULT_SURFACE = "#FFFFFF";
var DEFAULT_BACKGROUND = "#FFFFFF";
function toThemeString(value) {
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  return void 0;
}
function pickColor(source, key, fallback) {
  const value = source[key];
  return toThemeString(value) ?? fallback;
}
function omitKeys(source, keys) {
  return Object.entries(source).reduce((result, [key, value]) => {
    const stringValue = toThemeString(value);
    if (!keys.includes(key) && stringValue) {
      result[key] = stringValue;
    }
    return result;
  }, {});
}
function extractStatusColors(theme) {
  return Object.entries(theme).reduce((result, [key, value]) => {
    const stringValue = toThemeString(value);
    if (key.startsWith("status-") && stringValue) {
      result[key.replace("status-", "")] = stringValue;
    }
    return result;
  }, {});
}
function createMode(theme) {
  const colors = {
    primary: pickColor(theme, "primary", "#000000"),
    secondary: pickColor(theme, "secondary", pickColor(theme, "accent", "#000000")),
    accent: pickColor(theme, "accent", pickColor(theme, "secondary", "#000000")),
    success: pickColor(theme, "success", pickColor(theme, "green", "#2e7d32")),
    info: pickColor(theme, "info", pickColor(theme, "primary", "#1976d2")),
    warning: pickColor(theme, "warning", "#fb8c00"),
    error: pickColor(theme, "error", pickColor(theme, "red", "#d32f2f")),
    surface: pickColor(theme, "surface", DEFAULT_SURFACE),
    background: pickColor(theme, "background", pickColor(theme, "surface", DEFAULT_BACKGROUND))
  };
  const customColors = omitKeys(theme, [
    "primary",
    "secondary",
    "accent",
    "success",
    "info",
    "warning",
    "error",
    "surface",
    "background"
  ]);
  return {
    colors,
    customColors
  };
}
function isBrandTheme(theme) {
  return Boolean(theme && "kind" in theme && theme.kind === "brand-theme");
}
function adaptLegacyTheme(theme) {
  const lightMode = createMode(theme.vuetifyLightTheme);
  const darkMode = createMode(theme.vuetifyDarkTheme);
  return {
    kind: "brand-theme",
    name: theme.name,
    typography: {
      fontFamily: theme.font
    },
    assets: {
      loginBackground: theme.loginBackground
    },
    density: "default",
    layout: {
      navbar: {
        light: {
          background: pickColor(theme.vuetifyLightTheme, "navbar", lightMode.colors.primary)
        },
        dark: {
          background: pickColor(theme.vuetifyDarkTheme, "navbar", darkMode.colors.primary)
        }
      }
    },
    status: extractStatusColors(theme.vuetifyLightTheme),
    components: {
      button: {
        variant: "flat"
      },
      card: {
        rounded: "xl"
      },
      field: {
        variant: "outlined"
      }
    },
    modes: {
      light: lightMode,
      dark: darkMode
    }
  };
}
function resolveBrandTheme(theme) {
  if (isBrandTheme(theme)) {
    return theme;
  }
  return adaptLegacyTheme(theme);
}

// src/prod.ts
var import_dist = __toESM(require_dist());
var DefaultProductionConfig = {
  api: {
    baseUrl: "https://api.book-n-park.de/v4",
    clientId: "d4fd5464-cbfa-11ee-ad5d-0242ac130002"
  },
  tuDarmstadtCasUrl: "https://www.smartparking.tu-darmstadt.de/cas/",
  isDev: false,
  googleMapsKey: "AIzaSyDeyRs6vIg4ufT3qkmyXJfFEaHjlNROrPU",
  redirectUrl: "https://app.book-n-park.de",
  payPalClientId: "AaXgm4cuNSAMPuWh0B5CwFSYyjAauOnPS5_7B2fiKIMg4hfswmBUdY72fB9COqf4h-9L-ErCkCfBtUU0",
  theme: import_dist.BnpTheme,
  urls: [/app\.book-n-park\.de/]
};

// src/local.ts
var import_vuetify2_themes = __toESM(require_dist());
var DefaultLocalConfig = {
  api: {
    baseUrl: "http://localhost:8081",
    clientId: "77cdcf98-c9ca-464d-a706-cf863134b639"
  },
  isDev: true,
  tuDarmstadtCasUrl: "https://www.smartparking.tu-darmstadt.de/cas/",
  googleMapsKey: "AIzaSyAyBUTZpTF15l81omCoX5-zWba9A_fGwDc",
  redirectUrl: "https://classic.cluster.booknpark.de",
  payPalClientId: "AfDi-hay0UpaJKEQ9m1EwCMOYSYuln7LJSBEVBb7i_Ww7iARiZpmN1LyLpCOpH1ah1QLS4tdVr8hBqV3",
  theme: import_vuetify2_themes.BnpTheme,
  urls: [/localhost/]
};

// src/staging.ts
var import_vuetify2_themes2 = __toESM(require_dist());
var DefaultStagingConfig = {
  api: {
    baseUrl: "https://staging-api.cluster.booknpark.de/v4",
    clientId: "77cdcf98-c9ca-464d-a706-cf863134b639"
  },
  isDev: true,
  tuDarmstadtCasUrl: "https://www.smartparking.tu-darmstadt.de/cas/",
  googleMapsKey: "AIzaSyAyBUTZpTF15l81omCoX5-zWba9A_fGwDc",
  redirectUrl: "https://classic.cluster.booknpark.de",
  payPalClientId: "AfDi-hay0UpaJKEQ9m1EwCMOYSYuln7LJSBEVBb7i_Ww7iARiZpmN1LyLpCOpH1ah1QLS4tdVr8hBqV3",
  theme: import_vuetify2_themes2.BnpTheme,
  urls: [/.*\.booknpark\.de/]
};

// src/index.ts
function defineConfig(config) {
  return Object.keys(config).reduce(
    (configObject, key) => {
      configObject[key] = { ...DefaultProductionConfig, ...config[key] };
      return configObject;
    },
    {}
  );
}
function getBrandTheme(config) {
  return config.themeTokens ?? resolveBrandTheme(config.theme);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DefaultLocalConfig,
  DefaultProductionConfig,
  DefaultStagingConfig,
  defineConfig,
  getBrandTheme
});
